import { Component, OnChanges, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalizationService } from './services/localization.service';
import { locale } from 'moment';
import { ConfiguracionService } from './services/configuracion.service';
import {
  trigger,
  state,
  query,
  style,
  animate,
  transition
} from '@angular/animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnChanges {
  @ViewChild('loading', {static: true}) loadingComponent : HTMLDivElement;

  title = 'app';

  constructor(public translate: TranslateService, public localization: LocalizationService, public configuracion: ConfiguracionService) {
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang('es');

    // Pillo el idioma del navegador
    const browserLang = this.translate.getBrowserLang();

    console.log(browserLang);
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use(browserLang);

    this.localization.CurrentLanguagePrefix = '';
    if (browserLang === 'pt') {
      // this.CurrentLanguageSuffix = '_PT';
      this.localization.CurrentLanguagePrefix = '_PT';
    }
  }

  ngOnInit() {
    this.configuracion.getConfiguracion().subscribe((data: any) => { this.localization.URLAuthServer = data.url; });

    this.configuracion.getIdioma().subscribe((data: any) => {
      if (data.idioma != null) {
        this.translate.use(data.idioma.toLowerCase().substring(3));
        if (data.idioma.toLowerCase().substring(3) === 'pt') {
          this.localization.CurrentLanguagePrefix = '_PT';
        }
      } else {
        // Pillo el idioma del navegador
        const browserLang = this.translate.getBrowserLang();

        console.log(browserLang);
        // the lang to use, if the lang isn't available, it will use the current loader to get them
        this.translate.use(browserLang);

        this.localization.CurrentLanguagePrefix = '';
        if (browserLang === 'pt') {
          // this.CurrentLanguageSuffix = '_PT';
          this.localization.CurrentLanguagePrefix = '_PT';
        }
      }
    });
  }

  ngOnChanges() {
    this.loadingComponent.style.display = "none";

  }


}
